export default class PGlobal {}

PGlobal.app = null;
PGlobal.parent = null;
PGlobal.platform = "";
PGlobal.stage = null;
PGlobal.stageWidth = 0;
PGlobal.stageHeight = 0;

PGlobal.now = 0;
PGlobal.m = null;
PGlobal.proto = proto.com.proto;

PGlobal.loader = PIXI.loader;
PGlobal.resources = PIXI.loader.resources;
PGlobal.hasFocus = false;

PGlobal.formatDate = function(fmt, date) {
    let o = {
        "M+" : date.getMonth()+1,                 //月份
        "d+" : date.getDate(),                    //日
        "h+" : date.getHours(),                   //小时
        "m+" : date.getMinutes(),                 //分
        "s+" : date.getSeconds(),                 //秒
        "q+" : Math.floor((date.getMonth()+3)/3), //季度
        "S"  : date.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt))
        fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(var k in o)
        if(new RegExp("("+ k +")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
}

PGlobal.setParent = function(container) {
    PGlobal.parent = container;
    PGlobal.parent.onmouseover = (e) => PGlobal.mouseover(e);
    PGlobal.parent.onmouseout = (e) => PGlobal.mouseout(e);
}
PGlobal.mouseover = function(e) {
    PGlobal.hasFocus = true;
    //console.log("PGlobal.mouseover:" + PGlobal.hasFocus);
}
PGlobal.mouseout = function(e) {
    PGlobal.hasFocus = false;
    //console.log("PGlobal.mouseout:" + PGlobal.hasFocus);
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/PGlobal.js